module.exports = __webpack_public_path__ + "img/linkedin.0cbc1fdd.svg";